import ProductsPage from "./ProductsPage";
import ProductDetailPage from "./ProductDetailPage";
import ProductCreatePage from "./ProductCreatePage";
import { mockProductsData } from "./mockData";

export const ProductsPageType = {
	type: "products",
	defaultTitle: "Products",
	icon: "pricetag-outline",
	component: ProductsPage,
	getDefaultContent: () => ({
		products: mockProductsData,
	}),
	// Mock data for testing
	mockData: mockProductsData,

	// Products-specific section types
	sectionTypes: {
		productList: {
			type: "productList",
		},
		productDetail: {
			type: "productDetail",
		},
		productCreate: {
			type: "productCreate",
		},
		quickAccess: {
			type: "quickAccess",
		},
	},

	// Products-specific layouts
	layouts: {
		grid: {
			name: "Grid",
			description: "Products displayed in grid format",
		},
		list: {
			name: "List",
			description: "Products displayed in list format",
		},
	},
};

export { ProductDetailPage, ProductCreatePage };
